// extracted by mini-css-extract-plugin
module.exports = {"container":"LrvOtpInput_container__m0nX0","lightContainer":"LrvOtpInput_lightContainer__3whhF","darkContainer":"LrvOtpInput_darkContainer__1dYNv"};